import { Outlet } from "react-router-dom";
import { Heart } from "lucide-react";
import { APP_NAME, APP_TAGLINE } from "@/lib/constants";

export function AuthLayout() {
  return (
    <div className="grid min-h-screen w-full lg:grid-cols-2">
      <div className="flex flex-col justify-between p-8 sm:p-12">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <Heart className="h-4 w-4" aria-hidden="true" />
          </span>
          <span className="font-display text-lg font-semibold tracking-tight">{APP_NAME}</span>
        </div>

        <div className="mx-auto w-full max-w-sm py-16">
          <Outlet />
        </div>

        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} {APP_NAME}. All rights reserved.
        </p>
      </div>

      <div className="relative hidden overflow-hidden bg-primary lg:block">
        <div
          className="absolute inset-0 opacity-90"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, hsl(37 45% 48% / 0.35), transparent 45%), radial-gradient(circle at 80% 70%, hsl(0 0% 100% / 0.08), transparent 55%)",
          }}
        />
        <div className="relative flex h-full flex-col justify-end p-12">
          <blockquote className="font-display text-3xl font-medium leading-snug text-primary-foreground">
            "{APP_TAGLINE}"
          </blockquote>
          <p className="mt-4 max-w-md text-sm text-primary-foreground/75">
            One workspace for every organization, every planner, and every wedding you run — from first
            inquiry to the last dance.
          </p>
        </div>
      </div>
    </div>
  );
}
